// extracted by mini-css-extract-plugin
export default {"header":"StarredRow_header__Psitm","back":"StarredRow_back__hYqRQ","icon":"StarredRow_icon__w4f8n","label":"StarredRow_label__0gfcr","meta":"StarredRow_meta__cio9E"};